import { useEffect, useState } from "react";
import { userData, selectedOptic } from "../js/utils";
import { post } from "../js/post";

export function useDocumentTypes() {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ObtenerTiposDocumentoPaciente.php", {
      token: userData.token,
      optica: selectedOptic.id,
    });
    setList(response);
  }

  useEffect(() => {
    getData();
  }, []);

  return [list, getData];
}
